import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Save previous page (excluding auth pages) for post-signup redirect
    const authPaths = ['/auth', '/connexion', '/forgot-password', '/mot-de-passe-oublie', '/reset-password', '/nouveau-mot-de-passe'];
    if (!authPaths.includes(prevPathname.current)) {
      localStorage.setItem('gaius-last-page', prevPathname.current);
    }
    prevPathname.current = pathname;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
